module.exports = __webpack_public_path__ + "fonts/Flaticon2.a690b82a.eot";